import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {useDispatch as useStoreDispatch} from "react-redux";
import auth from "./api/AuthSlice";
import {employeeApi} from "./api/EmployeeApi";
import {categoryApi} from "./api/CategoryApi";
import {partnerApi} from "./api/PartnerApi";
import {cityApi} from "./api/CityApi";
import {orderApi} from "./api/OrderApi";

// Reducers
export const reducer = combineReducers({
    [employeeApi.reducerPath]: employeeApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [partnerApi.reducerPath]: partnerApi.reducer,
    [cityApi.reducerPath]: cityApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    auth
})

export interface AppThunkProps {
    dispatch: AppDispatch;
    state: StoreState;
    extra?: unknown;
    rejectValue?: unknown;
}

export type StoreState = ReturnType<typeof reducer>
export type AppDispatch = typeof store.dispatch

export const useDispatch = () => useStoreDispatch<AppDispatch>()

export const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({immutableCheck: false})
        .concat(employeeApi.middleware)
        .concat(categoryApi.middleware)
        .concat(partnerApi.middleware)
        .concat(cityApi.middleware)
        .concat(orderApi.middleware)
})